// extracted by mini-css-extract-plugin
export default {"container":"NoRecentLessons_container__WymJc"};